import type { ReactNode } from 'react';

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { cn } from '@/lib/utils';

export type FaqAccordionItem = { q: string; a: string | ReactNode };

export function FaqAccordion({
  items,
  defaultValue = ['q-0', 'q-1'],
  className,
  triggerClassName,
  triggerLabelClassName,
  toggleClassName,
  contentClassName,
}: {
  items: FaqAccordionItem[];
  defaultValue?: string[];
  className?: string;
  triggerClassName?: string;
  triggerLabelClassName?: string;
  toggleClassName?: string;
  contentClassName?: string;
}) {
  return (
    <Accordion type="multiple" defaultValue={defaultValue} className={className}>
      {items.map((item, idx) => (
        <AccordionItem
          key={item.q}
          value={`q-${idx}`}
          className="group border-t border-b-0 border-border first:border-t last:border-b"
        >
          <AccordionTrigger
            className={cn(
              'py-6 text-left leading-7 text-foreground hover:no-underline [&>svg]:hidden',
              triggerClassName
            )}
          >
            <span className="flex w-full items-start justify-between gap-4">
              <span className={cn('flex-1', triggerLabelClassName)}>{item.q}</span>
              <span aria-hidden="true" className={cn('leading-7 group-data-[state=open]:hidden', toggleClassName)}>
                +
              </span>
              <span
                aria-hidden="true"
                className={cn('hidden leading-7 group-data-[state=open]:inline', toggleClassName)}
              >
                −
              </span>
            </span>
          </AccordionTrigger>
          <AccordionContent>
            <p className={cn('leading-6 text-foreground-soft', contentClassName)}>{item.a}</p>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
